import { FrozenCardModal } from 'components/cash/FrozenCardModal/FrozenCardModal';
import InactiveCardWarningModal from 'partial/OfferManager/modules/SesameCashModule/components/InactiveCardWarningModal';
import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { CASH_BALANCE } from 'types/morph.pagePosition.constants';
import { AccountOptionsLinks } from 'components/cash/AccountOptionsLinks/AccountOptionsLinks';
import { BalanceView } from 'components/cash/BalanceView/BalanceView';
import { isCardStatusFrozen } from 'pages/Cash/helpers/cashHelpers';

export const CashBalanceModule = ({
  sesameCashAccount,
  handleAccountOptionsClick,
  modulePosition,
  frozenModalOpen,
  handleCloseFrozenModal,
  inactiveCardWarningModalOpen,
  toggleInactiveCardWarningModal,
  onClickChat,
  builderManager,
  ...props
}) => {
  const datatestid = 'cashBalance';
  const seenPixel = useSeenModulePixel(
    getViewModuleTrackingAttributes(CASH_BALANCE, modulePosition, CASH_BALANCE),
  );

  const frozenCard = isCardStatusFrozen(sesameCashAccount);
  return (
    <SectionContainer datatestid={datatestid}>
      {seenPixel}
      <Row datatestid={datatestid}>
        <FlexContainer className="flex-mobile-col justify-between align-items-center mobile-items-align-start gap-16">
          <BalanceView
            datatestid={datatestid}
            balance={props.displayBalance}
            updateDate={props.updateDate}
            frozenCard={frozenCard}
            builderManager={builderManager}
            sesameCashAccount={sesameCashAccount}
            userInfo={props.userInfo}
          />
          <div className="padB24 desktopHide" />
          <FlexContainer className="format50 m-format100 t-format50">
            <AccountOptionsLinks
              datatestid={datatestid}
              handleAccountOptionsClick={handleAccountOptionsClick}
            />
          </FlexContainer>
        </FlexContainer>
      </Row>
      <FrozenCardModal
        visible={frozenModalOpen}
        onCancel={handleCloseFrozenModal}
      />
      <InactiveCardWarningModal
        inactiveCardWarningModalOpen={inactiveCardWarningModalOpen}
        toggleInactiveCardWarningModal={toggleInactiveCardWarningModal}
        onClickChat={onClickChat}
      />
    </SectionContainer>
  );
};
